"use client";
import styles from "./InputDesign.module.css";

export const UserProfile = ({ 
  isEditable, 
  profileImage, 
  isUploading, 
  fileInputRef, 
  handleImageClick, 
  handleFileChange, 
  formData, 
  handleLogout 
}) => {
  return (
    <div>
      <section className={styles.userProfileCard}>
        <img
          src={profileImage}
          alt="User avatar"
          className={`${styles.avatar} ${isEditable ? styles.editable : ''}`}
          onClick={handleImageClick}
        />
        {isEditable && (
          <button
            className={styles.imgEditBtn}
            onClick={handleImageClick}
            disabled={isUploading}
          >
            {isUploading ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <i className="fas fa-camera"></i>
            )}
          </button>
        )}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          className={styles.fileInput}
        />
        <div className={styles.userInfo}>
          <h2 className={styles.userName}>
            {formData?.firstName} {formData?.lastName}
          </h2>
          <p className={styles.userEmail}>{formData?.email}</p>
          <p className={styles.userPhone}>{formData?.phone}</p>
          <button 
            className={styles.logoutLink}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </section>
    </div>
  );
};
